module.exports = __webpack_public_path__ + "../resources/images/drophint_2x_s_bw-f9378961471dc9c1275def2154616f60.png";